import React from "react";
import { Button, Row, Col, Icon, Tooltip } from "antd";
import PageLayout from "../../ui/PageLayout";
import BarrierMemberEdit from "./BarrierMemberEdit";
import { global_data } from '../../ui/auth'

class BarrierMemberIndex extends React.Component {
  columns = [
    {
      title: "编号",
      dataIndex: "code",
      width: "15%",
    },
    {
      title: "名称",
      dataIndex: "name",
      width: "15%",
    },
    {
      title: "状态",
      dataIndex: "state",
      width: "15%",
      render: (text, record, index) => (
        <div>{record.state === -1 ? "失效" : "生效"}</div>
      ),
    },
    {
      title: "操作",
      dataIndex: "id",
      width: "20%",
      render: (text, record, index) => (
        <div>
          {global_data.authCode.includes("BARRIER_ONLY_MEMBER_UPDATE")?
          <Tooltip title="修改">
            <Icon
              type="edit"
              theme="filled"
              title="修改"
              className="table-operate-icon"
              onClick={this.update.bind(this, record)}
            />
          </Tooltip>
          :""}
        </div>
      ),
    },
  ];

  state = {
    visible: false,
    editData: {},
    loadData: "",
    queryData: {},
  };

  add = () => {
    this.setState({ editData: { state: 0 } });
    this.showModal();
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };

  update = (info, e) => {
    this.setState({ editData: info });
    this.showModal();
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={16}>
                {global_data.authCode.includes("BARRIER_ONLY_MEMBER_ADD")?
                <Button type="primary" onClick={this.add}>
                  新增
                </Button>
                :""}
              </Col>
            </Row>
          }
          rowKey="id"
          url="/barrier/plateNoCard/members"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <BarrierMemberEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
          queryData={this.state.queryData}
        />
      </div>
    );
  }
}

export default BarrierMemberIndex;
